import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CompaniesSection = () => {
  const companies = [
    {
      name: 'Vallet Prime',
      subtitle: 'Valet Parking & Motorista Executivo',
      description: 'Empresa especializada em valet parking e motorista executivo, com foco em atendimento premium, segurança e organização.',
      icon: 'ri-car-line',
      features: ['Valet Parking', 'Motorista Executivo'],
    },
    {
      name: 'TR Prorok',
      subtitle: 'Logística & Movimentação',
      description: 'Empresa especializada em logística, transporte e movimentação de mobiliário para eventos e empresas.',
      icon: 'ri-truck-line',
      features: ['Logística', 'Movimentação', 'Fretes Corporativos'],
    },
  ];

  return (
    <section className="bg-primary py-32 lg:py-40 overflow-hidden">
      <div className="w-full px-12 lg:px-20">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <span className="inline-block text-xs font-semibold tracking-[0.2em] text-white/40 uppercase mb-4">
            Nossas Empresas
          </span>
          <h2 className="text-3xl lg:text-4xl font-medium text-white leading-tight mb-6">
            Empresas do Grupo
          </h2>
          <p className="text-white/50 text-lg max-w-xl mx-auto">
            Especialização e integração operacional para atender todas as suas necessidades
          </p>
        </motion.div>

        {/* Companies Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {companies.map((company, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-10 lg:p-12 hover:bg-white/10 hover:border-white/20 transition-all duration-500 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-16 h-16 rounded-xl bg-accent/20 flex items-center justify-center mb-8">
                <i className={`${company.icon} text-3xl text-accent`}></i>
              </div>

              {/* Content */}
              <h3 className="text-3xl font-semibold text-white mb-2">
                {company.name}
              </h3>
              <p className="text-accent text-sm font-medium tracking-wide uppercase mb-6">
                {company.subtitle}
              </p>
              <p className="text-white/60 text-base leading-relaxed mb-8">
                {company.description}
              </p>

              {/* Features */}
              <div className="flex flex-wrap gap-2 mb-8">
                {company.features.map((feature, idx) => (
                  <span
                    key={idx}
                    className="px-4 py-2 bg-white/5 border border-white/10 rounded-full text-white/70 text-xs font-medium"
                  >
                    {feature}
                  </span>
                ))}
              </div>

              {/* Link */}
              <Link
                to="/empresas-do-grupo"
                className="inline-flex items-center gap-2 text-accent font-medium text-sm group-hover:gap-4 transition-all duration-300"
              >
                Conhecer empresa
                <i className="ri-arrow-right-line"></i>
              </Link>

              {/* Decorative */}
              <div className="absolute top-10 right-10 w-24 h-24 border border-white/5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompaniesSection;
